import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tAlarm Definitions\r\n\t\t\t\t", -1 /* HOISTED */);
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Name *", -1 /* HOISTED */);
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", null, "Severity", -1 /* HOISTED */);
const _hoisted_9 = { class: "col-xs-12 col-sm-12 bottom10" };
const _hoisted_10 = { class: "checkbox-wrapper" };
const _hoisted_11 = { class: "float-end float-start-sm" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_14 = { class: "clearfix" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "float-end" }, [
        /*#__PURE__*/ _createCommentVNode("<b-button variant=\"primary\" @click=\"add\">\r\n\t\t\t\t\t\t\t\t\t<span class=\"fa fa-plus\"></span><span class=\"hidden-xs\">&nbsp;Add Alarm Definition</span>\r\n\t\t\t\t\t\t\t\t</b-button>")
    ])
], -1 /* HOISTED */);
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_17 = { class: "card bg-white data-grid alarm-definition-grid detached overflow-x-auto" };
const _hoisted_18 = { class: "table table-hover table-fixed bottom0 pw100" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tName\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tSeverity\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tHigh / Low\r\n\t\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_20 = { class: "text-center hidden-sm" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "clearfix visible-sm" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "clearfix" };
const _hoisted_26 = { class: "text-center hidden-sm" };
const _hoisted_27 = { class: "text-center hidden-sm" };
const _hoisted_28 = { key: 0 };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "4"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_30 = [
    _hoisted_29
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CollapsibleForm, null, {
            title: _withCtx(() => [
                _hoisted_2
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_b_modal, {
                            id: "alarm_definition",
                            modelValue: _ctx.editingAlarmDefinition,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.editingAlarmDefinition) = $event)),
                            "header-bg-variant": "normal",
                            size: "lg"
                        }, {
                            title: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tAlarm Definiton\r\n\t\t\t\t\t\t\t")
                            ]),
                            footer: _withCtx(() => [
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _ctx.save
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_12,
                                            _createTextVNode(" Save\r\n\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"]),
                                    _createTextVNode(),
                                    _createCommentVNode("<b-button type=\"button\" variant=\"danger\" @click=\"archive(alarmDefinition)\" v-if=\"!isNewAlarmDefinition && !isArchivedAlarmDefinition\">\r\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-trash\"></i>&nbsp;Archive\r\n\t\t\t\t\t\t\t\t\t</b-button>\r\n\t\t\t\t\t\t\t\t\t<b-button type=\"button\" variant=\"warning\" @click=\"restore(alarmDefinition)\" v-if=\"!isNewAlarmDefinition && isArchivedAlarmDefinition\">\r\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-refresh\"></i>&nbsp;Restore\r\n\t\t\t\t\t\t\t\t\t</b-button>"),
                                    _createTextVNode(),
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "secondary",
                                        onClick: _ctx.cancel
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_13,
                                            _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"])
                                ])
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(),
                                _createVNode(_component_b_container, { clearfix: "" }, {
                                    default: _withCtx(() => {
                                        var _a;
                                        return [
                                            _createElementVNode("div", _hoisted_5, [
                                                _hoisted_6,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                    name: "alarmDefinitionName",
                                                    type: "text",
                                                    maxlength: "255",
                                                    modelValue: _ctx.alarmDefinition.alarmDefinitionName,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.alarmDefinition.alarmDefinitionName) = $event)),
                                                    modelModifiers: { trim: true },
                                                    class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name }
                                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_7, [
                                                _hoisted_8,
                                                _createTextVNode(),
                                                _createVNode(_component_multiselect, {
                                                    name: "alarmSeverityId",
                                                    modelValue: _ctx.alarmSeverity,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.alarmSeverity) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.alarmSeverities,
                                                    showLabels: false,
                                                    allowEmpty: false
                                                }, {
                                                    noResult: _withCtx(() => [
                                                        _createTextVNode("No results found")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createVNode(_component_b_form_checkbox, {
                                                        id: "displayValue",
                                                        modelValue: _ctx.alarmDefinition.showValue,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.alarmDefinition.showValue) = $event)),
                                                        size: "lg"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tDisplay Value\r\n\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["modelValue"]),
                                                    _createTextVNode(),
                                                    _createVNode(_component_b_form_checkbox, {
                                                        id: "isHighAlarm",
                                                        modelValue: _ctx.alarmDefinition.showHighValue,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.alarmDefinition.showHighValue) = $event)),
                                                        size: "lg",
                                                        disabled: !_ctx.alarmDefinition.showValue
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tHigh alarm\r\n\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["modelValue", "disabled"])
                                                ])
                                            ])
                                        ];
                                    }),
                                    _: 1 /* STABLE */
                                }),
                                _createTextVNode()
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("table", _hoisted_18, [
                                    _hoisted_19,
                                    _createTextVNode(),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                class: _normalizeClass({ 'deleted': item.whenDeleted })
                                            }, [
                                                _createElementVNode("td", _hoisted_20, [
                                                    _createVNode(_component_b_button_group, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown, {
                                                                variant: "outline-secondary dots",
                                                                size: "sm",
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.edit(item))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _hoisted_21,
                                                                            _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                                    _createTextVNode(),
                                                                    _createVNode(_component_b_dropdown_divider),
                                                                    _createTextVNode(),
                                                                    _createCommentVNode("<b-dropdown-item v-show=\"!item.whenDeleted\" @click=\"archive(item)\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"fa fa-trash\"></span>&nbsp;Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</b-dropdown-item>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b-dropdown-item v-show=\"item.whenDeleted\" @click=\"restore(item)\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"fa fa-refresh\"></span>&nbsp;Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</b-dropdown-item>")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("a", {
                                                        class: "blue hidden-sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, _toDisplayString(item.alarmDefinitionName), 9 /* TEXT, PROPS */, _hoisted_22),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createElementVNode("a", {
                                                            class: "lead",
                                                            onClick: ($event) => (_ctx.edit(item))
                                                        }, _toDisplayString(item.alarmDefinitionName), 9 /* TEXT, PROPS */, _hoisted_24),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_25, _toDisplayString(item.alarmSeverityName) + " | " + _toDisplayString(item.whenMarkedAsHighAlarm ? 'High' : 'Low') + " alarm\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("td", _hoisted_26, _toDisplayString(item.alarmSeverityName), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _createElementVNode("td", _hoisted_27, _toDisplayString(item.whenMarkedAsHighAlarm ? 'High' : 'Low'), 1 /* TEXT */)
                                            ], 2 /* CLASS */));
                                        }), 256 /* UNKEYED_FRAGMENT */))
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tfoot", null, [
                                        (_ctx.noData)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_28, _hoisted_30))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
